/**
 * TableRenderer - 멀티 에이전트 응답의 테이블 데이터 렌더링
 */
import React from 'react';
import './TableRenderer.css';

const TableRenderer = ({ data }) => {
  if (!data || !data.columns || !data.rows) {
    return <div className="table-error">테이블 데이터가 없습니다.</div>;
  }

  const { columns, rows, total_count, displayed_count } = data;

  return (
    <div className="table-renderer">
      <table>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th key={idx}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIdx) => (
            <tr key={rowIdx}>
              {row.map((cell, cellIdx) => (
                <td key={cellIdx}>
                  {typeof cell === 'number'
                    ? cell.toLocaleString()
                    : cell !== null && cell !== undefined
                    ? String(cell)
                    : '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {total_count > displayed_count && (
        <div className="table-footer">
          * {displayed_count}개 행만 표시됨 (전체: {total_count.toLocaleString()}개)
        </div>
      )}
    </div>
  );
};

export default TableRenderer;
